import { find, get } from "lodash";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import isEmail from "validator/lib/isEmail";
import isEmpty from "validator/lib/isEmpty";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import {
  onChangeInputType,
  onSaveContactForm,
  postContact,
  resetContactForm
} from "~/store/contact/contactAction";
import * as hospitalActions from "~/store/hospital/hospitalActions";
import { patternMobile, patternPhone } from "~/utils/constants";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ContactPageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Contact"),
  loading: LoadableLoading
});

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listProblem: [
        { id: 0, name: "Chọn vấn đề" },
        { id: 1, name: "Vấn đề chuyên môn" },
        { id: 2, name: "Vấn đề kỹ thuật" },
        { id: 3, name: "Vấn đề khác" }
      ],
      chosenType: 0
    };
  }

  method = {
    handleSelectHospital: event => {
      this.props.selectHospital(Number(event));
    },

    validatorName: (rule, value, callback) => {
      if (value) {
        value = value.toLowerCase();
        value = value.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        value = value.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        value = value.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        value = value.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        value = value.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        value = value.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        value = value.replace(/đ/g, "d");
        const patternName = /^[a-zA-Z ]+$/;
        if (patternName.test(value)) {
          callback();
        } else {
          callback("Họ tên chỉ bao gồm chữ cái!");
        }
      } else {
        callback();
      }
      callback();
    },

    validatorEmail: (rule, value, callback) => {
      if (typeof value !== typeof undefined && !!value) {
        const trimValue = (value + "").trim();
        if (!isEmpty(trimValue)) {
          if (!isEmail(trimValue)) {
            callback("Vui lòng nhập đúng định dạng email !");
          } else callback();
        } else callback();
      } else callback();
    },

    validatorMobile: (rule, value, callback) => {
      if (value) {
        if (patternMobile.test(value)) {
          callback();
        } else {
          if (patternPhone.test(value)) {
            callback();
          } else callback("Vui lòng nhập đúng định dạng!");
        }
      } else {
        callback("Vui lòng nhập số điện thoại!");
      }
    },

    validatorType: (rule, value, callback) => {
      if (Number(value) === 0) {
        callback("Vui lòng chọn loại vấn đề!");
      } else {
        callback();
      }
    }
  };

  componentDidUpdate() {
    const { data } = this.props;
    if (data.id !== 0) {
      this.props.resetContactForm();
    }
  }

  render() {
    return (
      <React.Fragment>
        <ContactPageDesktop {...this.state} {...this.props} {...this.method} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    hospital: {
      hospitalList: { data: hospitalList },
      selectedHospital
    },
    contact: { contactForm, error, data }
  } = state;
  return {
    device: type,
    hospitalList,
    contactForm,
    selectedHospital,
    error,
    data
  };
};

const mapDispatchToProps = dispatch => ({
  onSaveContactForm: fields => {
    dispatch(onSaveContactForm(fields));
  },
  onChangeInputType: fields => {
    dispatch(onChangeInputType(fields));
  },
  postContact: contact => {
    dispatch(postContact(contact));
  },
  requestHospitalList: () => dispatch(hospitalActions.requestHospitalList()),
  selectHospital: id => {
    dispatch(hospitalActions.selectHospital(id));
  },
  resetContactForm: () => {
    dispatch(resetContactForm());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
